import { render } from "./parts.vue?vue&type=template&id=6a974495"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__